// extracted by mini-css-extract-plugin
export default {"base":"styles-module--base--c3e22","show":"styles-module--show--d5213"};